// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamGetManyBody = {
  teamIds: string[];
};

export type typeTeamGetManyOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teams: {
      teamId: string;
      leagueId: string;
      name: string;
      abbreviation: string;
    }[];
    missingTeamIds: string[];
  };
};

export type typeTeamGetManyOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamGetManyOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamGetManyOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamGetManyBody = {
  type: "object",
  properties: {
    teamIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["teamIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamGetMany(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamGetManyBody);
  }

  return async function postTeamGetMany(
    payload: typeTeamGetManyBody,
  ): Promise<typeTeamGetManyOutput200 | typeTeamGetManyOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamGetMany" failed before calling the network. #e6533fc58063`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#e6533fc58063" },
        },
        data: null,
      } as typeTeamGetManyOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/get-many`,
      httpMethod: "POST",
      options,
    })) as typeTeamGetManyOutput200 | typeTeamGetManyOutput400;
  };
}
